module.exports = __webpack_public_path__ + "static/img/m_role.17d3afe.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/role3/ch/m_role.png
// module id = +6JQ
// module chunks = 7